import { useState, useEffect } from 'react';
import axios from 'axios';
import config from './../../config';
import { useTranslation } from 'react-i18next';

export default function useHeaderData() {
  const { t } = useTranslation();
  const [menuServices, setMenuServices] = useState([]);
  const [menuDocument, setMenuDocument] = useState([]);
  const [headerData, setHeaderData] = useState([]);

  const getAllMenu = async () => {
    try {
      const response = await axios.get(`${config.SITE_API_URL}/active_menu_service`);
      setMenuServices(response?.data || []);
    } catch (error) {
      console.error('Error fetching menu services:', error);
      setMenuServices([]);
    }
  };

  const getAllMenuDocument = async () => {
    try {
      const response = await axios.get(`${config.SITE_API_URL}/active_menu_document`);
      setMenuDocument(response?.data || []);
    } catch (error) {
      console.error('Error fetching menu documents:', error);
      setMenuDocument([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getAllMenu(), getAllMenuDocument()]);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setHeaderData([
      {
        title: t('header.home'),
        link: '/',
      },
      {
        title: t('header.about'),
        link: '/apropos',
      },
      {
        title: t('header.courses'),
        link: '/course',
      },
      {
        title: t('header.subscription'),
        link: '/subscription',
      },
      {
        title: t('header.contact'),
        link: '/contact',
      },
    ]);
  }, [t, menuServices, menuDocument]);

  return headerData;
}